import React from 'react'


export default function Navbar(props) {
  return (
    <>
    <div>
      <nav className={`navbar navbar-expand-lg bg-${props.mode} `}>
  <div className={`container-fluid text-${props.mode}`} >
    <a  className={`navbar-brand ${props.mode === 'light'? 'text-dark':'text-light'}`} href="#" >{props.name}</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className={`nav-link ${props.mode === 'light'? 'text-dark':'text-light'} `} aria-current="page" style={{fontWeight: 700}} href="#">Home</a>
        </li>
        <li className="nav-item">
          <a className={`nav-link ${props.mode === 'light'? 'text-dark':'text-light'}`} href="https://github.com/yogendradevil">About Us</a>
        </li>
      </ul>
      <div class={`form-check form-switch ${props.mode === 'light'? 'text-dark':'text-light'}`}>
  <input class="form-check-input" type="checkbox" onClick={props.toggleMode} role="switch" id="flexSwitchCheckDefault" />
  <label class="form-check-label" for="flexSwitchCheckDefault">{props.mode === 'light'? 'Dark mode':'Light mode'}</label>
</div>
    </div>
  </div>
</nav>
    </div>
    </>
  )
}
